import View from '../view/view';

import { requestify, } from '../utils/promisify';
import { beginLock, endLock } from '../loader';





const Application = View.extend( {
    
    el: document.body,
    
    template: 'jst/application',

    popup(mod, module, state, ...args) {
        return this.module( mod, module, state, ...args );
    },

    open(mod, module, state, ...args ) {
        return this.module( mod, module, state, ...args );
    },

    module(mod, module, state, ...args) {
        module.$el
            // this is hack
            .css( { opacity: 0, /*transform: 'scale(0.01)'*/ } )
            // this is not
            .appendTo( document.body );
        
        const startingModule = mod.init()
            .then( () => module.inject( mod.injectable() ) )
            .then( () => module.setState( state ) )
            .then( () => module.open( ...args ) )
            .then( result => result instanceof Array
                    ? result : [result] );
        // mark that THIS mod (not another one) 
        // must be shown in application after starting.
        this.last = startingModule;
        
        beginLock( this );

        const startingProcess = requestify( startingModule ).then( ([module, ...args]) => {
            // some module is opening now,
            // our module is outdated.
            if (startingModule !== this.last) return;

            // remove currently shown module
            if (this.currentModule) {
                this.currentModule
                    .$el.detach();

                this.currentModule
                    .detached()
                    .stop();
                
                this.stopListening( this.currentModule );
            }

            // and remember new one.
            this.currentModule = module;
            
            endLock( this );
            module.$el
                // this is hack
                .css( { opacity: 1, /* transform: '' */ } );

            // clear container for module and 
            // notify it about attachment
            module
                .attached( this.$el )
                .navigated()
                .start( ...args );
        } );
        
        return startingProcess.catch( cause => {
            // some module is opening now,
            // our module is outdated.
            if (startingModule !== this.last) return;
            
            console.error( 'Failed to open module, reason is ' + cause );

            throw cause;
        } );
    }
    
} );

export {
    Application,
};



// WEBPACK FOOTER //
// ./src/js/core/application.js